import React from "react";
import classNames from "classnames/bind";
import styles from "./PrivacyPolicy.module.scss";
import CustomEditor from "../commons/Editor/Editor";

const cx = classNames.bind(styles);

export default function PrivacyPolicy({
  tabButtons,
  currentItem,
  changeItem,
  privacyPolicy,
  editorRef,
  handleEditorChange,
  handleSubmit,
}) {
  return (
    <>
      <div className={cx("tab_box")}>
        {tabButtons.map((tab, index) => (
          <button
            key={tab.id}
            onClick={() => changeItem(index)}
            className={cx(
              "tab_button",
              currentItem.id === tab.id && "tab_button_active"
            )}
          >
            {tab.tab}
          </button>
        ))}
      </div>
      <CustomEditor
        key={`${currentItem.locale}-${privacyPolicy.locale}`}
        name="content"
        editorRef={editorRef}
        initialValue={privacyPolicy?.content}
        handleEditorChange={handleEditorChange}
        placeholder="개인정보 처리 방침을 작성해 주세요."
      />
      <div className={cx("button_box")}>
        <button className={cx("button")} onClick={handleSubmit}>
          저장 하기
        </button>
      </div>
    </>
  );
}
